import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox']

  toggle = (event) => {
    if (event.target.type !== 'checkbox') {
      const checkbox = this.checkboxTarget
      checkbox.checked = !checkbox.checked
    }

    // Toggle selected state class on the container
    const container = event.currentTarget
    container.classList.toggle('border-indigo-600')
    container.classList.toggle('bg-indigo-50')
    container.classList.toggle('border-gray-200')
  }
}
